import { apiSlice } from "../apiSlice";

export const mipuestoApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getMipuestoPestanas: builder.query({
      query: () => ({
        url: `/Mipuesto/getPestanas`,
        method: "GET",
      }),
    }),
    //Carga del Ejecutivo de Cuenta frente a su tope (null para los demás cargos)
    getMipuestoMiCarga: builder.query({
      query: () => ({
        url: `/Mipuesto/miCarga`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    //Turno del Ejecutivo: hasta cuándo está en turno y qué operaciones recibió en esta entrega (null si no trabaja por turnos)
    getMipuestoMiTurno: builder.query({
      query: () => ({
        url: `/Mipuesto/miTurno`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    //Prórroga del turno del Ejecutivo: 15 minutos más antes de entregar
    prorrogarMipuestoMiTurno: builder.mutation({
      query: () => ({
        url: `/Mipuesto/miTurno/prorroga`,
        method: "POST",
      }),
    }),
    getMipuestoMiDia: builder.query({
      query: () => ({
        url: `/Mipuesto/getMiDia`,
        method: "GET",
      }),
    }),
    getMipuestoContadores: builder.query({
      query: () => ({
        url: `/Mipuesto/getContadores`,
        method: "GET",
      }),
    }),
    agregarMipuestoPestana: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/pestanas`,
        method: "POST",
        body: parameters,
      }),
    }),
    quitarMipuestoPestana: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/pestanas/${parameters.MODIDXXX}/${parameters.PROIDXXX}`,
        method: "DELETE",
      }),
    }),
    ordenarMipuestoPestanas: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/pestanas/ordenar`,
        method: "PUT",
        body: parameters,
      }),
    }),
    getMipuestoWidgets: builder.query({
      query: () => ({
        url: `/Mipuesto/widgets`,
        method: "GET",
      }),
    }),
    getCatalogoDashboards: builder.query({
      query: () => ({
        url: `/Usuarios/Dashboar/catalogo`,
        method: "GET",
      }),
    }),
    agregarMipuestoWidget: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/widgets`,
        method: "POST",
        body: parameters,
      }),
    }),
    quitarMipuestoWidget: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/widgets/${parameters.GRAIDXXX}`,
        method: "DELETE",
      }),
    }),
    ordenarMipuestoWidgets: builder.mutation({
      query: (parameters) => ({
        url: `/Mipuesto/widgets/ordenar`,
        method: "PUT",
        body: parameters,
      }),
    }),
    //Vuelve el escritorio a la plantilla del cargo (Diego 2026-09-12, regla 4)
    restablecerMipuestoWidgets: builder.mutation({
      query: () => ({
        url: `/Mipuesto/widgets/restablecer`,
        method: "PUT",
      }),
    }),
  }),
});

export const {
  useLazyGetMipuestoPestanasQuery,
  useLazyGetMipuestoContadoresQuery,
  useLazyGetMipuestoMiDiaQuery,
  useAgregarMipuestoPestanaMutation,
  useQuitarMipuestoPestanaMutation,
  useOrdenarMipuestoPestanasMutation,
  useGetMipuestoWidgetsQuery,
  useLazyGetMipuestoWidgetsQuery,
  useLazyGetCatalogoDashboardsQuery,
  useAgregarMipuestoWidgetMutation,
  useQuitarMipuestoWidgetMutation,
  useOrdenarMipuestoWidgetsMutation,
  useRestablecerMipuestoWidgetsMutation,
  useGetMipuestoMiCargaQuery,
  useGetMipuestoMiTurnoQuery,
  useProrrogarMipuestoMiTurnoMutation,
} = mipuestoApiSlice;
